/**
 * contains the abi and contract address
*/

class SequencesContract {
    constructor() {
        this.abi = [
	{
		"constant": false,
		"inputs": [
			{
				"name": "previousSequences",
				"type": "bytes32[4]"
			},
			{
				"name": "newSequence",
				"type": "bytes32"
			},
			{
				"name": "diff",
				"type": "bytes32"
			},
			{
				"name": "title",
				"type": "string"
			}
		],
		"name": "editCompoundSequence",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "previousSequence",
				"type": "bytes32"
			},
			{
				"name": "newSequence",
				"type": "bytes32"
			},
			{
				"name": "diff",
				"type": "bytes32"
			},
			{
				"name": "title",
				"type": "string"
			}
		],
		"name": "editSequence",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"name": "userEditing",
				"type": "address"
			},
			{
				"indexed": true,
				"name": "previousSequence",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"name": "newSequence",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"name": "diffHash",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"name": "title",
				"type": "string"
			}
		],
		"name": "SequenceEdited",
		"type": "event"
	}
        ];

        this.contractAddress = '0x16687b7db5994ac1aa22594be04af8396f5085dd';
    }
}

export default SequencesContract;
	
